import styles from "../../components/processed-data/processed-data";
import { Tag } from "primereact/tag";
import { Button } from "primereact/button";
import functionListStyles from "../../container/Function-setup/functionList.module.scss";
import orderSummaryStyles from "../../components/orderSummary/orderSummary.module.scss";
import { useContext } from "react";
import FeatureFlagDataContext from "../../store/featureFlags";
import { maxHeight, maxWidth, minWidth } from "@mui/system";

// const showFtp = JSON.parse(
//   localStorage.getItem("ApplicationSettings")
// )?.enableFTPAutomatedOrders;
// const showReProcessBtn = JSON.parse(
//   localStorage.getItem("ApplicationSettings")
// )?.enableReprocessFiles;

const getSeverity = (Status) => {
  switch (Status) {
    case "error":
      return "danger";

    case "Success":
      return "success";
    case "Warning":
      return "warning";
    case "info":
      return "info";
    default:
      return "danger";
  }
};
const statusBodyTemplate = (rowData) => {
  return (
    <Tag
      value={rowData.errors === null ? "Success" : "Error"}
      className={styles.tag}
      icon={
        rowData.errors !== null ? "pi pi-info-circle" : "pi pi-check-circle"
      }
      severity={getSeverity(rowData.errors === null ? "Success" : "error")}
    />
  );
};
const openErrorDiaolog = (rowData, setShowErrorDialog, setErrorList) => {
  setShowErrorDialog(true);
  setErrorList(rowData?.errors);
};
const errorBodyTemplate = (rowData, setShowErrorDialog, setErrorList) => {
  return (
    <>
      {rowData.errors !== null && (
        <i
          className="pi pi-info-circle"
          style={{ cursor: "pointer" }}
          onClick={() =>
            openErrorDiaolog(rowData, setShowErrorDialog, setErrorList)
          }
        />
      )}
    </>
  );
};

export const createOrderColumns = (setShowErrorDialog, setErrorList) => [
  {
    field: "rowNumber",
    header: "Row",
    minWidth: "4rem",
    sort: true,
    frozen: true
  },
  {
    field: "function",
    header: "Status",
    minWidth: "",
    columnType: "fun",
    frozen: true,
    columnDefination: statusBodyTemplate
  },
  {
    field: "errors",
    header: "Error",
    minWidth: "6rem",
    sort: true,
    columnType: "fun",
    columnDefination: (rowData) =>
      errorBodyTemplate(rowData, setShowErrorDialog, setErrorList)
  },
  {
    field: "shipReqDateStr",
    header: "Ship Request Date",
    minWidth: "6rem",
    sort: true
  },
  { field: "custId", header: "Cust ID", minWidth: "6rem", sort: true },
  { field: "custName", header: "Cust Name", minWidth: "6rem", sort: true },
  { field: "wrhs", header: "WRHS", minWidth: "", sort: true },
  { field: "dstItem", header: "DST Item", minWidth: "6rem", sort: true },
  { field: "name", header: "Name", minWidth: "12rem", sort: true },
  { field: "srcItem", header: "Src Item", minWidth: "6rem", sort: true },
  { field: "uom", header: "UOM", minWidth: "6rem", sort: true },
  { field: "sun", header: "Sun", minWidth: "4rem", sort: true },
  { field: "mon", header: "Mon", minWidth: "4rem", sort: true },
  { field: "tue", header: "Tue", minWidth: "4rem", sort: true },
  { field: "wed", header: "Wed", minWidth: "4rem", sort: true },
  { field: "thu", header: "Thu", minWidth: "4rem", sort: true },
  { field: "fri", header: "Fri", minWidth: "4rem", sort: true },
  { field: "sat", header: "Sat", minWidth: "4rem", sort: true },
  { field: "total", header: "Total", minWidth: "4rem", sort: true },
  { field: "srcStore", header: "Src Store", minWidth: "6rem", sort: true },
  { field: "customerPO", header: "Customer PO", minWidth: "6rem", sort: true },
  {
    field: "purchaseList",
    header: "Purchase List",
    minWidth: "6rem",
    sort: true
  },
  {
    field: "receiptDateStr",
    header: "Receipt Date",
    minWidth: "6rem",
    sort: true
  },
  {
    field: "inventBatchID",
    header: "Inv BatchId",
    minWidth: "6rem",
    sort: true
  },
  { field: "invAccount", header: "Inv Account", minWidth: "6rem", sort: true },
  { field: "route", header: "Route", minWidth: "6rem", sort: true },
  { field: "stop", header: "Stop", minWidth: "6rem", sort: true }
];

export const createCreditInvoiceColumns = [
  {
    field: "function",
    header: "Status",
    minWidth: "6rem",
    columnType: "fun",
    frozen: true,
    columnDefination: statusBodyTemplate
  },
  {
    field: "errors",
    header: "Error",
    minWidth: "18rem",
    sort: true,
    columnType: "fun"
  },
  {
    field: "regionCode",
    header: "Region Code",
    minWidth: "8rem"
  },
  {
    field: "creditPercentage",
    header: "Credit %",
    minWidth: "8rem"
  },
  {
    field: "customerName",
    header: "Cust Name",
    minWidth: "16rem",
    sort: false
  },
  {
    field: "invoiceAccount",
    header: "Invoice Account",
    minWidth: "8rem",
    sort: true
  },
  {
    field: "salesId",
    header: "Sales Id",
    minWidth: "8rem",
    sort: false
  },
  {
    field: "invoiceNumber",
    header: "Invoice Id",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "vantagePointSentDate",
    header: "Vantage Point Sent Date",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "poNumber",
    header: "PO Number",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "creditTotal",
    header: "Credit Total",
    minWidth: "12rem",
    sort: true
  }
];

export const rowExpansionCreateCreditInvoiceLineItemColumns = [
  {
    field: "function",
    header: "Status",
    minWidth: "6rem",
    columnType: "fun",
    columnDefination: statusBodyTemplate
  },
  {
    field: "errors",
    header: "Error",
    minWidth: "18rem",
    sort: true,
    columnType: "fun"
  },
  {
    field: "buyerItemId",
    header: "External Item Id",
    minWidth: "1rem",
    sort: false
  },
  {
    field: "sellerItemId",
    header: "Taylorfarms Item Id",
    minWidth: "1rem",
    sort: false
  },
  {
    field: "qty",
    header: "Quantity",
    minWidth: "1rem",
    sort: false
  },
  { field: "uom", header: "UOM", minWidth: "1rem", sort: true },
  {
    field: "salesPrice",
    header: "Sales Price",
    minWidth: "1rem",
    sort: false
  },
  {
    field: "lineAmount",
    header: "Line Amount",
    minWidth: "1rem",
    sort: false
  }
];

const functionStatusBodyTemplate = (
  rowData,
  navigateToFunctionForm,
  deleteFunction
) => {
  const showAction =
    rowData?.loggedInUserRoleId === 1
      ? true
      : rowData?.loggedInUserRoleId !== 1 && rowData?.functionRoleId === 4
        ? true
        : false;
  const showView =
    rowData?.loggedInUserRoleId === 1
      ? true
      : rowData?.loggedInUserRoleId !== 1 && rowData?.functionRoleId === 4
        ? true
        : rowData?.loggedInUserRoleId !== 1 && rowData?.functionRoleId === 5
          ? true
          : false;
  return (
    <>
      {showAction && (
        <Button
          icon="pi pi-pencil"
          severity="warning"
          aria-label="Edit"
          className={`${functionListStyles.editBtn} ${functionListStyles.btns} `}
          onClick={() => navigateToFunctionForm("edit", rowData?.functionId)}
        />
      )}
      {showView && (
        <Button
          icon="pi pi-eye"
          severity="warning"
          aria-label=""
          className={`${functionListStyles.viewBtn} ${functionListStyles.btns} `}
          onClick={() => navigateToFunctionForm("view", rowData?.functionId)}
        />
      )}
      {showAction && (
        <Button
          icon="pi pi-trash"
          severity="warning"
          aria-label="Delete"
          className={`${functionListStyles.dltBtn} ${functionListStyles.btns} `}
          onClick={() => deleteFunction(rowData?.functionId)}
        />
      )}
    </>
  );
};

export const Functioncolumns = (
  navigateToFunctionForm,
  deleteFunction,
  enableFTPAutomatedOrders
) => {
  const columns = [
    { field: "regionName", header: "Region", minWidth: "8rem", sort: true },
    {
      field: "functionName",
      header: "Function",
      minWidth: "8rem",
      sort: true
    },
    {
      field: "createdDate",
      header: "Created Date",
      minWidth: "10rem",
      sort: true
    },
    { field: "createdBy", header: "Created By", minWidth: "9rem", sort: true },
    { field: "status", header: "Status", minWidth: "6rem", sort: true },
    {
      field: "function",
      header: "Actions",
      minWidth: "8rem",
      sort: false,
      columnType: "fun",
      columnDefination: (rowData) =>
        functionStatusBodyTemplate(
          rowData,
          navigateToFunctionForm,
          deleteFunction
        )
    }
  ];

  if (enableFTPAutomatedOrders) {
    columns.splice(columns?.length - 1, 1);
    columns.push({
      field: "functionType",
      header: "Function Type",
      minWidth: "10rem",
      sort: true
    });
    columns.push({
      field: "function",
      header: "Actions",
      minWidth: "8rem",
      sort: false,
      columnType: "fun",
      columnDefination: (rowData) =>
        functionStatusBodyTemplate(
          rowData,
          navigateToFunctionForm,
          deleteFunction
        )
    });
  }

  return columns;
};

const expectedQtyTemplate = (rowData) => {
  return (
    <Tag
      className={orderSummaryStyles.tag}
      severity={getSeverity(
        rowData?.color === 1
          ? "Success"
          : rowData?.color === 2
            ? "info"
            : rowData?.color === 3
              ? "error"
              : "Warning"
      )}
    >
      <div className="flex align-items-center gap-2">
        {rowData?.isAcceptableRange ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
          >
            <path
              d="M9.49935 11.833H1.75268C1.33417 11.833 0.932605 11.6676 0.635427 11.373C0.33825 11.0783 0.169533 10.6781 0.166016 10.2596V6.49962C0.167779 6.07997 0.335723 5.67811 0.63309 5.38199C0.930457 5.08587 1.33302 4.91962 1.75268 4.91962H3.08602L4.90602 0.859624C5.03033 0.582124 5.25807 0.364123 5.54074 0.252053C5.8234 0.139982 6.13866 0.142699 6.41935 0.259624C6.79448 0.425812 7.11292 0.697926 7.33557 1.04256C7.55822 1.38719 7.67538 1.78934 7.67268 2.19962V3.84629H10.3393C10.3769 3.83995 10.4152 3.83995 10.4527 3.84629C10.8753 3.92775 11.2515 4.16587 11.506 4.51296C11.7464 4.83361 11.8517 5.23564 11.7993 5.63296L11.066 10.493C11.0073 10.8663 10.8172 11.2064 10.53 11.4521C10.2428 11.6977 9.87729 11.8328 9.49935 11.833V11.833ZM3.87935 10.833H9.49935C9.63829 10.8348 9.77326 10.7866 9.87971 10.6973C9.98616 10.608 10.057 10.4834 10.0793 10.3463L10.826 5.50629C10.8352 5.44007 10.8305 5.37265 10.8121 5.30836C10.7937 5.24407 10.7621 5.18433 10.7193 5.13296C10.6111 4.98977 10.4549 4.89037 10.2793 4.85296H7.16602C7.09953 4.85388 7.03355 4.84136 6.97203 4.81613C6.91051 4.79091 6.85473 4.75352 6.80802 4.70619C6.76132 4.65887 6.72467 4.60259 6.70027 4.54074C6.67586 4.4789 6.66421 4.41276 6.66602 4.34629V2.19962C6.66691 1.98302 6.60422 1.77092 6.48571 1.58961C6.36721 1.40829 6.1981 1.26574 5.99935 1.17962C5.96041 1.16413 5.91695 1.16453 5.87831 1.18073C5.83966 1.19694 5.80892 1.22766 5.79268 1.26629L3.87935 5.52629V10.833ZM1.75268 5.91962C1.67596 5.91874 1.59982 5.93309 1.52868 5.96185C1.45754 5.9906 1.39281 6.03318 1.33824 6.08713C1.28368 6.14107 1.24036 6.20531 1.21079 6.27612C1.18123 6.34692 1.16601 6.42289 1.16602 6.49962V10.2596C1.16689 10.3358 1.18275 10.411 1.21271 10.4811C1.24266 10.5511 1.28612 10.6146 1.3406 10.6678C1.39507 10.721 1.45951 10.763 1.53021 10.7914C1.60092 10.8197 1.67651 10.8338 1.75268 10.833H2.87935V5.91962H1.75268Z"
              fill="white"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            style={{ transform: "rotateX(180deg)" }}
          >
            <path
              d="M9.49935 11.833H1.75268C1.33417 11.833 0.932605 11.6676 0.635427 11.373C0.33825 11.0783 0.169533 10.6781 0.166016 10.2596V6.49962C0.167779 6.07997 0.335723 5.67811 0.63309 5.38199C0.930457 5.08587 1.33302 4.91962 1.75268 4.91962H3.08602L4.90602 0.859624C5.03033 0.582124 5.25807 0.364123 5.54074 0.252053C5.8234 0.139982 6.13866 0.142699 6.41935 0.259624C6.79448 0.425812 7.11292 0.697926 7.33557 1.04256C7.55822 1.38719 7.67538 1.78934 7.67268 2.19962V3.84629H10.3393C10.3769 3.83995 10.4152 3.83995 10.4527 3.84629C10.8753 3.92775 11.2515 4.16587 11.506 4.51296C11.7464 4.83361 11.8517 5.23564 11.7993 5.63296L11.066 10.493C11.0073 10.8663 10.8172 11.2064 10.53 11.4521C10.2428 11.6977 9.87729 11.8328 9.49935 11.833V11.833ZM3.87935 10.833H9.49935C9.63829 10.8348 9.77326 10.7866 9.87971 10.6973C9.98616 10.608 10.057 10.4834 10.0793 10.3463L10.826 5.50629C10.8352 5.44007 10.8305 5.37265 10.8121 5.30836C10.7937 5.24407 10.7621 5.18433 10.7193 5.13296C10.6111 4.98977 10.4549 4.89037 10.2793 4.85296H7.16602C7.09953 4.85388 7.03355 4.84136 6.97203 4.81613C6.91051 4.79091 6.85473 4.75352 6.80802 4.70619C6.76132 4.65887 6.72467 4.60259 6.70027 4.54074C6.67586 4.4789 6.66421 4.41276 6.66602 4.34629V2.19962C6.66691 1.98302 6.60422 1.77092 6.48571 1.58961C6.36721 1.40829 6.1981 1.26574 5.99935 1.17962C5.96041 1.16413 5.91695 1.16453 5.87831 1.18073C5.83966 1.19694 5.80892 1.22766 5.79268 1.26629L3.87935 5.52629V10.833ZM1.75268 5.91962C1.67596 5.91874 1.59982 5.93309 1.52868 5.96185C1.45754 5.9906 1.39281 6.03318 1.33824 6.08713C1.28368 6.14107 1.24036 6.20531 1.21079 6.27612C1.18123 6.34692 1.16601 6.42289 1.16602 6.49962V10.2596C1.16689 10.3358 1.18275 10.411 1.21271 10.4811C1.24266 10.5511 1.28612 10.6146 1.3406 10.6678C1.39507 10.721 1.45951 10.763 1.53021 10.7914C1.60092 10.8197 1.67651 10.8338 1.75268 10.833H2.87935V5.91962H1.75268Z"
              fill="white"
            />
          </svg>
        )}
        <span style={{ fontWeight: "12px" }}>
          {rowData?.itemRangeDescription}
        </span>
      </div>
    </Tag>
  );
};

const showxmlfile = (rawData, showModal) => {
  return (
    <>
      {rawData?.fileUrl !== null ? (
        <i
          className={`pi pi-file ${functionListStyles.fileIcon}`}
          onClick={(e) => {
            showModal(rawData);
          }}
        ></i>
      ) : (
        ""
      )}
    </>
  );
};

const showReProcess = (rowData, reprocess, proceed) => {
  return (
    <>
      {rowData.isFileEligibleForReprocess && (
        <Button
          label="ReProcess"
          icon="pi pi-replay"
          className={`${functionListStyles.reprocessBtn}`}
          onClick={(e) => {
            reprocess(rowData);
          }}
        />
      )}
      {rowData.isEligibleForProceed && (
        <Button
          label="Proceed"
          className={`${functionListStyles.prpceedBtn}`}
          onClick={(e) => {
            proceed(rowData);
          }}
        />
      )}
    </>
  );
};

const showlineItems = (rowData, lineItems) => {
  return (
    <>
      {rowData?.fileUrl == null && (
        <Button
          label="View Details"
          icon="pi pi-info-circle"
          className={`${functionListStyles.reprocessBtn} }`}
          onClick={(e) => lineItems(rowData?.lineItems)}
        />
      )}
    </>
  );
};

export const orderSummaryColumns = [
  { field: "itemId", header: "AX Item", minWidth: "8rem", sort: true },
  { field: "description", header: "Name", minWidth: "10rem", sort: true },
  { field: "quantity", header: "Qty Order", minWidth: "10rem", sort: true },
  {
    field: "itemTolerancePercentage",
    header: "Tolerance %",
    minWidth: "8rem",
    sort: true
  },
  {
    field: "isAcceptableRange",
    header: "% of Expected Qty",
    minWidth: "12rem",
    sort: false,
    columnType: "fun",
    columnDefination: (rowData) => expectedQtyTemplate(rowData)
  }
];

export const itemXrefColumns = [
  { field: "region", header: "Region", minWidth: "8rem", sort: true },
  {
    field: "customerName",
    header: "Customer Name",
    minWidth: "8rem",
    sort: true
  },
  { field: "buyerItemId", header: "Buyer Item ID", minWidth: "8rem", sort: true },

  {
    field: "sellerItemId",
    header: "Seller Item ID",
    minWidth: "8rem",
    sort: true
  },
  {
    field: "itemDescription",
    header: "Item Description",
    minWidth: "8rem",
    sort: true
  },
  {
    field: "uom",
    header: "UOM",
    minWidth: "8rem",
  },
];
export const shipToXrefColumns = [
  { field: "region", header: "Region", minWidth: "8rem", sort: true },
  { field: "customerName", header: "Customer Name", minWidth: "12rem", sort: true },
  { field: "buyerShipToId", header: "Buyer Ship To Id", minWidth: "12rem", sort: true },
  { field: "sellerShipToId", header: "Seller Ship To Id", minWidth: "12rem", sort: true },
  { field: "shipToDescription", header: "Store Name", minWidth: "12rem", sort: true },
  { field: "street", header: "Street", minWidth: "10rem", sort: true },
  { field: "city", header: "City", minWidth: "8rem", sort: true },
  { field: "state", header: "State", minWidth: "8rem", sort: true },
  { field: "country", header: "Country", minWidth: "8rem", sort: true },
  { field: "zipCode", header: "Zip Code", minWidth: "8rem", sort: true }
];
const formatDateFromUTCtoPST = (date, time, flag) => {
  let utcDateString = date;
  let utcTimeString = time;

  if (
    utcDateString != null &&
    utcDateString?.trim() != "" &&
    utcTimeString != null &&
    utcTimeString?.trim() != ""
  ) {
    let utcDateTimeString = `${utcDateString} ${utcTimeString} UTC`;
    let utcDate = new Date(utcDateTimeString);
    let options = {
      timeZone: "America/Los_Angeles",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    };
    let pstDateTime = new Intl.DateTimeFormat("en-US", options).format(utcDate);
    if (flag === "date") {
      return pstDateTime.split(",")[0];
    } else if (flag === "time") {
      return pstDateTime.split(",")[1].trim();
    }
  } else {
    return "";
  }
};

export const logSummaryColumns = [
  {
    field: "successFiles",
    header: "Results",
    minWidth: "4rem",
    sort: true,
    columnType: "fun",
    columnDefination: (rowData) =>
      `Completed ${rowData.successFiles}/${rowData.numberOfFiles}`
  },
  { field: "functionName", header: "Function", minWidth: "4rem", sort: true },
  {
    field: "orderDate",
    header: "Date",
    minWidth: "4rem",
    sort: true,
    columnType: "fun",
    columnDefination: (rowData) =>
      formatDateFromUTCtoPST(rowData?.orderDate, rowData?.orderTime, "date")
  },
  {
    field: "orderTime",
    header: "Time",
    minWidth: "4rem",
    sort: true,
    columnType: "fun",
    columnDefination: (rowData) =>
      formatDateFromUTCtoPST(rowData?.orderDate, rowData?.orderTime, "time")
  },
  {
    field: "createdBy",
    header: "Who",
    minWidth: "4rem",
    sort: true
  },
  {
    field: "numberOfFiles",
    header: "# Items",
    minWidth: "4rem",
    sort: true
  }
];

export const autoLogSummaryColumns = [
  { field: "actualPos", header: "Actual PO's", minWidth: "8rem", sort: true },
  {
    field: "invalidPos",
    header: "Invalid PO's",
    minWidth: "8rem",
    sort: true
  },
  {
    field: "d365ProcessedPos",
    header: "D365 Processed PO's",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "d365FailedPos",
    header: "D365 Failed PO's",
    minWidth: "10rem",
    sort: true
  },
  { field: "functionName", header: "Function", minWidth: "10rem", sort: true },
  {
    field: "orderDate",
    header: "Date",
    minWidth: "4rem",
    sort: true,
    columnType: "fun",
    columnDefination: (rowData) =>
      formatDateFromUTCtoPST(rowData?.orderDate, rowData?.orderTime, "date")
  },
  {
    field: "orderTime",
    header: "Time",
    minWidth: "4rem",
    sort: true,
    columnType: "fun",
    columnDefination: (rowData) =>
      formatDateFromUTCtoPST(rowData?.orderDate, rowData?.orderTime, "time")
  },
  {
    field: "rawFileName",
    header: "File Name",
    minWidth: "8rem",
    sort: true
  }
];
export const rowExpansionLogSummaryColumns = (
  screenFlag,
  reProcessItem,
  proceed,
  showReprocessbtn
) => {
  const columns = [];
  columns.push(
    {
      field: "createdTime",
      header: "Time",
      width: "10rem",
      maxWidth: screenFlag == "showAuto" ? "4rem" : "",
      sort: true,
      columnType: "fun",
      columnDefination: (rowData) =>
        formatDateFromUTCtoPST(
          rowData?.createdDate,
          rowData?.createdTime,
          "time"
        )
    },
    {
      field: "shipReqDate",
      header: "Ship request date",
      maxWidth: screenFlag == "showAuto" ? "4rem" : "",
      width: "12rem",
      sort: true
    },
    {
      field: "customerId",
      header: "Cust ID",
      width: "8rem",
      maxWidth: screenFlag == "showAuto" ? "4rem" : "",
      sort: true
    },
    {
      field: "itemQty",
      header: "Items Qty",
      width: "8rem",
      maxWidth: screenFlag == "showAuto" ? "4rem" : "",
      sort: true
    },
    {
      field: "poNumber",
      header: "PO#",
      width: "4rem",
      maxWidth: screenFlag == "showAuto" ? "5rem" : "",
      sort: true
    },
    {
      field: "fileName",
      header: "XML File",
      width: "2rem",
      maxWidth: screenFlag == "showAuto" ? "4rem" : "",
      sort: true,
      columnType: "fun",
      columnDefination: (rowData, setVisible) =>
        showxmlfile(rowData, setVisible)
    },
    {
      field: "status",
      header: "Status",
      width: "12rem",
      maxWidth: screenFlag == "showAuto" ? "5rem" : "",
      sort: true
    },
    {
      field: "errorMsg",
      header: "Error",
      width: "16rem",
      maxWidth: screenFlag == "showAuto" ? "10rem" : "",
      sort: true
    },
    {
      field: "",
      header: "Action",
      width: "4rem",
      maxWidth: screenFlag == "showAuto" ? "5rem" : "",
      sort: false,
      columnType: "fun",
      columnDefination: (rowData) =>
        showReProcess(rowData, reProcessItem, proceed)
    }
  );
  if (!showReprocessbtn) {
    columns?.splice(columns?.length - 1, 1);
  }
  if (screenFlag == "showAuto") {
    columns.splice(7, 0, {
      field: "",
      header: "Line Items",
      width: "8rem",
      maxWidth: "6rem",
      sort: true,
      columnType: "fun",
      columnDefination: (rowData, setxml, setShowLineItems) =>
        showlineItems(rowData, setShowLineItems)
    });
  }
  return columns;
};
export const rowExpansionLogSummaryColumnsErrors = [
  {
    field: "rowNumber",
    header: "Row",
    minWidth: "4rem",
    sort: true,
    frozen: true
  },
  {
    field: "function",
    header: "Status",
    minWidth: "",
    frozen: true,
    columnType: "fun",
    columnDefination: statusBodyTemplate
  },
  {
    field: "errors",
    header: "Error",
    minWidth: "6rem",
    sort: true,
    columnType: "fun",
    columnDefination: (rowData, setShowErrorDialog, setErrorList) =>
      errorBodyTemplate(rowData, setShowErrorDialog, setErrorList)
  },
  {
    field: "shipReqDateStr",
    header: "Ship Request Date",
    minWidth: "6rem",
    sort: true
  },
  { field: "custId", header: "Cust ID", minWidth: "6rem", sort: true },
  { field: "custName", header: "Cust Name", minWidth: "6rem", sort: true },
  { field: "wrhs", header: "WRHS", minWidth: "", sort: true },
  { field: "dstItem", header: "DST Item", minWidth: "6rem", sort: true },
  { field: "name", header: "Name", minWidth: "12rem", sort: true },
  { field: "srcItem", header: "Src Item", minWidth: "6rem", sort: true },
  { field: "uom", header: "UOM", minWidth: "6rem", sort: true },
  { field: "sun", header: "Sun", minWidth: "4rem", sort: true },
  { field: "mon", header: "Mon", minWidth: "4rem", sort: true },
  { field: "tue", header: "Tue", minWidth: "4rem", sort: true },
  { field: "wed", header: "Wed", minWidth: "4rem", sort: true },
  { field: "thu", header: "Thu", minWidth: "4rem", sort: true },
  { field: "fri", header: "Fri", minWidth: "4rem", sort: true },
  { field: "sat", header: "Sat", minWidth: "4rem", sort: true },
  { field: "total", header: "Total", minWidth: "4rem", sort: true },
  { field: "srcStore", header: "Src Store", minWidth: "6rem", sort: true },
  { field: "customerPO", header: "Customer PO", minWidth: "6rem", sort: true },
  {
    field: "purchaseList",
    header: "Purchase List",
    minWidth: "6rem",
    sort: true
  },
  {
    field: "receiptDateStr",
    header: "Receipt Date",
    minWidth: "6rem",
    sort: true
  },
  {
    field: "inventBatchID",
    header: "Inv BatchId",
    minWidth: "6rem",
    sort: true
  },
  { field: "invAccount", header: "Inv Account", minWidth: "6rem", sort: true },
  { field: "route", header: "Route", minWidth: "6rem", sort: true },
  { field: "stop", header: "Stop", minWidth: "6rem", sort: true }
];

export const ediFilePurchaseOrderColumns = [
  {
    field: "poNumber",
    header: "PO#",
    minWidth: "8rem",
    sort: true
  },
  {
    field: "deliveryDate",
    header: "PO Created Date",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "vendorSequenceNumber",
    header: "Vendor Sequence Number",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "distributionCenterNumber",
    header: "D. C. Number",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "actualFulfillmentRegion",
    header: "Region",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "processingStatus",
    header: "Status",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "approvedBy",
    header: "Approved By",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "buyingPartyName",
    header: "Buying Party",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "supplierName",
    header: "Supplier",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "ediFileCreatedDateUTC",
    header: "Edi File Created Date UTC",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "ediFileName",
    header: "Edi File Name",
    minWidth: "12rem",
    sort: true
  }
];

export const rowExpansionEdiLineItemsColumns = [
  {
    field: "itemDescription",
    header: "Item Description",
    minWidth: "15rem",
    sort: true
  },
  {
    field: "buyersItemId",
    header: "Buyers Item Id",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "sellersItemId",
    header: "Sellers Item Id",
    minWidth: "60rem",
    sort: true
  }
];

export const ediFilePurchaseOrderReProcessColumns = [
  {
    field: "poNumber",
    header: "PO#",
    minWidth: "8rem",
    sort: true
  },
  {
    field: "vendorSequenceNumber",
    header: "Vendor Sequence Number",
    minWidth: "8rem",
    sort: true
  },
  {
    field: "distributionCenterNumber",
    header: "D. C. Number",
    minWidth: "8rem",
    sort: true
  },
  {
    field: "actualFulfillmentRegion",
    header: "Region",
    minWidth: "8rem",
    sort: true
  }
];

export const ediDuplicateColumns = [
  {
    field: "purchaseOrderNumber",
    header: "PO#",
    minWidth: "8rem",
    sort: true
  },
  {
    field: "deliveryDate",
    header: "PO Created Date",
    minWidth: "4rem",
    sort: true
  },
  {
    field: "processingStatus",
    header: "Status",
    minWidth: "4rem",
    sort: true
  }
];
const actionButtons = (rowData, editItem, deleteItem) => {
  return (
    <div className="flex justify-content-start">
      <Button
        icon="pi pi-pencil"
        severity="warning"
        aria-label="Edit"
        className="px-4 edit_btn"
        onClick={() => editItem(rowData)}
      />
      <Button
        icon="pi pi-trash"
        severity="primary"
        aria-label="Delete"
        className="px-4 edit_btn delete_btn"
        onClick={() => deleteItem(rowData)}
      />
    </div>
  );
};

export const userManagement = (editItem, deleteItem) => [
  {
    field: "functions",
    header: "Actions",
    minWidth: "6rem",
    columnType: "fun",
    columnDefination: (rowData) => actionButtons(rowData, editItem, deleteItem)
  },
  {
    field: "userName",
    header: "Name",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "roleName",
    header: "Role",
    minWidth: "9rem",
    sort: true
  },
  {
    field: "emailAdrress",
    header: "Email Address",
    minWidth: "13rem",
    sort: true
  },
  {
    field: "regionNameAbbr",
    header: "Region",
    minWidth: "8rem",
    sort: true
  },
  {
    field: "timezoneName",
    header: "TimeZone",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "createdby",
    header: "Created By",
    minWidth: "10rem",
    sort: true
  }
];

export const CreditInvoicesSummaryColumns = [
  {
    field: "function",
    header: "Status",
    minWidth: "6rem",
    columnType: "fun",
    frozen: true,
    columnDefination: statusBodyTemplate
  },
  {
    field: "errors",
    header: "Error",
    minWidth: "18rem",
    sort: true,
    columnType: "fun"
  },
  {
    field: "regionCode",
    header: "Region",
    minWidth: "8rem",
    sort: true
  },
  {
    field: "creditPercentage",
    header: "Credit %",
    minWidth: "8rem"
  },
  {
    field: "createdDate",
    header: "Date",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "invoiceProcessedTimePST",
    header: "Time (PST)",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "createdBy",
    header: "Created By",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "customerName",
    header: "Cust Name",
    minWidth: "16rem",
    sort: false
  },
  {
    field: "salesId",
    header: "Sales Id",
    minWidth: "8rem",
    sort: false
  },
  {
    field: "invoiceNumber",
    header: "Invoice Id",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "edI894FileName",
    header: "EDI File",
    minWidth: "20rem",
    sort: false
  },
  {
    field: "poNumber",
    header: "PO Number",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "creditTotal",
    header: "Credit Total",
    minWidth: "12rem",
    sort: true
  }
];
export const rowExpansionCreditInvoicesSummaryLineItemColumns = [
  {
    field: "buyerItemId",
    header: "External Item Id",
    minWidth: "1rem",
    sort: false
  },
  {
    field: "sellerItemId",
    header: "Taylorfarms Item Id",
    minWidth: "1rem",
    sort: false
  },
  {
    field: "qty",
    header: "Quantity",
    minWidth: "1rem",
    sort: false
  },
  { field: "uom", header: "UOM", minWidth: "1rem", sort: true },
  {
    field: "salesPrice",
    header: "Sales Price",
    minWidth: "1rem",
    sort: false
  },
  {
    field: "lineAmount",
    header: "Line Amount",
    minWidth: "1rem",
    sort: false
  }
];
export const emailOrderColumns = [
  {
    field: "purchaseOrderNumber",
    header: "PO#",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "approvalStatus",
    header: "Approval Status",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "d365Status",
    header: "D365 Status",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "message",
    header: "D365 Message",
    minWidth: "28rem",
    sort: true
  },
  {
    field: "tradingPartnerName",
    header: "Trading Partner Name",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "requestedShippingDate",
    header: "Requested Ship Date",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "requestedReceiptDate",
    header: "Requested Receipt Date",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "content",
    header: "Original Content",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "senderEmailId",
    header: "Sender Email ID",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "emailRecievedDateTime",
    header: "Email Received (Pacific Time)",
    minWidth: "18rem",
    sort: true
  },
  {
    field: "region",
    header: "Region",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "invoiceAccount",
    header: "Invoice Account",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "sellersShipToId",
    header: "Sellers Ship To Id",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "buyersShipToId",
    header: "Buyers Ship To Id",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "actiontakenBy",
    header: "Reviewed By",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "actionTakenDateUTC",
    header: "Reviewed On (Pacific Time)",
    minWidth: "16rem",
    sort: true
  }

];

export const rowExpansionEmailOrderLineItemsColumns = [
  {
    field: "buyersItemId",
    header: "Buyers Item Id",
    minWidth: "2rem",
    sort: true
  },
  {
    field: "sellersItemId",
    header: "Sellers Item Id",
    minWidth: "2rem",
    sort: true
  },
  {
    field: "quantity",
    header: "Quantity",
    minWidth: "2rem",
    sort: true
  },
  {
    field: "unitOfMeasuerement",
    header: "Unit Of Measurement",
    minWidth: "2rem",
    sort: true
  }
];

export const currencyConversionColumns = [
  {
    field: "date",
    header: "Date",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "time",
    header: "Time",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "usdToMxn",
    header: "USD To MXN",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "usdToCad",
    header: "USD To CAD",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "mxnToUsd",
    header: "MXN To USD",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "cadToUsd",
    header: "CAD To USD",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "updatedBy",
    header: "Generated By",
    minWidth: "10rem",
    sort: true
  }
];

export const excelOrderColumns = [
  {
    field: "purchaseOrderNumber",
    header: "PO#",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "tradingPartnerName",
    header: "Trading Partner Name",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "requestedShippingDate",
    header: "Requested Ship Date",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "requestedReceiptDate",
    header: "Requested Receipt Date",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "excelContent",
    header: "Original Excel File",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "approvalStatus",
    header: "Approval Status",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "region",
    header: "Region",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "invoiceAccount",
    header: "Invoice Account",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "sellersShipToId",
    header: "Sellers Ship To Id",
    minWidth: "12rem",
    sort: true
  }
];

export const rowExpansionExcelOrderLineItemsColumns = [
  {
    field: "buyersItemId",
    header: "Buyers Item Id",
    minWidth: "4rem",
    sort: true
  },
  {
    field: "sellersItemId",
    header: "Sellers Item Id",
    minWidth: "4rem",
    sort: true
  },
  {
    field: "quantity",
    header: "Quantity",
    minWidth: "4rem",
    sort: true
  },
  {
    field: "unitOfMeasuerement",
    header: "Unit Of Measurement",
    minWidth: "40rem",
    sort: true
  }
];

export const apiOrderColumns = [
  {
    field: "purchaseOrderNumber",
    header: "PO#",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "tradingPartnerName",
    header: "Trading Partner Name",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "requestedShippingDate",
    header: "Requested Ship Date",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "requestedReceiptDate",
    header: "Requested Receipt Date",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "apiContent",
    header: "Raw API Content",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "approvalStatus",
    header: "Approval Status",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "region",
    header: "Region",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "invoiceAccount",
    header: "Invoice Account",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "sellersShipToId",
    header: "Sellers Ship To Id",
    minWidth: "12rem",
    sort: true
  }
];

export const rowExpansionApiOrderLineItemsColumns = [
  {
    field: "buyersItemId",
    header: "Buyers Item Id",
    minWidth: "4rem",
    sort: true
  },
  {
    field: "sellersItemId",
    header: "Sellers Item Id",
    minWidth: "4rem",
    sort: true
  },
  {
    field: "quantity",
    header: "Quantity",
    minWidth: "4rem",
    sort: true
  },
  {
    field: "unitOfMeasuerement",
    header: "Unit Of Measurement",
    minWidth: "40rem",
    sort: true
  }
];

export const phoneOrderColumns = [
  {
    field: "poNumber",
    header: "PO#",
    minWidth: "8rem",
    sort: true
  },
  {
    field: "name",
    header: "Name",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "phoneNumber",
    header: "Phone Number",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "email",
    header: "Email",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "tradingPartnerName",
    header: "Trading Partner Name",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "shipDate",
    header: "Ship Date",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "receiptDate",
    header: "Receipt Date",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "shipTo",
    header: "Ship To",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "region",
    header: "Region",
    minWidth: "10rem",
    sort: true
  }
];

export const rowExpansionPhoneOrderLineItemsColumns = [
  {
    field: "buyersItemId",
    header: "Buyers Item Id",
    minWidth: "4rem",
    sort: true
  },
  {
    field: "sellersItemId",
    header: "Sellers Item Id",
    minWidth: "4rem",
    sort: true
  },
  {
    field: "quantity",
    header: "Quantity",
    minWidth: "4rem",
    sort: true
  },
  {
    field: "itemDescription",
    header: "Item Description",
    minWidth: "40rem",
    sort: true
  }
];

export const regionMappingColumns = [
  {
    field: "vendorSequenceNumber",
    header: "Vendor Sequence Number",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "dcNumber",
    header: "D.C. Number",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "regionCode",
    header: "Region",
    minWidth: "8rem",
    sort: true
  },
  {
    field: "regionSelectionStatus",
    header: "Processing Status",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "isAutomated",
    header: "Automatic Status",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "approvedBy",
    header: "Approved By",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "approvedDateUTC",
    header: "Approved Date UTC",
    minWidth: "16rem",
    sort: true
  }
];

export const duplicateOrdersSummaryColumns = [
  {
    field: "d365Status",
    header: "D365 Status",
    minWidth: "8rem",
    columnType: "fun",
    frozen: true,
    columnDefination: statusBodyTemplate
  },
  {
    field: "message",
    header: "Message",
    minWidth: "18rem",
    sort: true,
    columnType: "fun"
  },
  {
    field: "processingStatusId",
    header: "Processing Status",
    minWidth: "4rem",
    sort: true,
    columnType: "fun"
  },
  {
    field: "regionCode",
    header: "Region",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "customerPo",
    header: "Customer PO#",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "shipRequestdate",
    header: "Ship Request Date",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "customerId",
    header: "Customer ID",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "customerName",
    header: "Customer Name",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "createdBy",
    header: "Created By",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "createdDate",
    header: "Created Date",
    minWidth: "10rem",
    sort: true
  },
];

export const duplicateLineItemsSummaryColumns = [
  {
    field: "qty",
    header: "QTY",
    minWidth: "8rem",
    sort: true
  },
  {
    field: "uom",
    header: "UOM",
    minWidth: "8rem",
    sort: true
  },
  {
    field: "srcItem",
    header: "Buyer Item ID",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "name",
    header: "Item Description",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "dstItem",
    header: "Seller Item ID",
    minWidth: "12rem",
    sort: true
  }
];


export const duplicateOrdersColumns = [
  {
    field: "customerPo",
    header: "PO#",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "shipRequestDate",
    header: "Ship Date",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "customerId",
    header: "Customer ID",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "customerName",
    header: "Customer Name",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "salesOrderNumber",
    header: "Sales ID",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "receiptDate",
    header: "Receipt Date",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "action",
    header: "Action",
    minWidth: "14rem",
    sort: true
  }
];

export const duplicateOrdersLineItemsColumns = [
  {
    field: "customerPo",
    header: "Customer PO#",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "shipRequestDate",
    header: "Ship Requested Date",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "quantity",
    header: "QTY",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "unit",
    header: "UOM",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "customerId",
    header: "Customer Id",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "customerName",
    header: "Customer Name",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "buyerItemId",
    header: "Buyer Item Id",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "itemDescription",
    header: "Item Description",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "sellerItemId",
    header: "Seller Item Id",
    minWidth: "10rem",
    sort: true
  }
];

export const purchaseOrderInvoiceColumns = [
  {
    field: "poNumber",
    header: "PO Number",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "d365Status",
    header: "D365 Status",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "d365ErrorMessage",
    header: "D365 Message",
    minWidth: "30rem",
    sort: true
  },
  {
    field: "source",
    header: "Source",
    minWidth: "12rem",
    sort: true
  },
  // TODO:NTD
  // {
  //   field: "blobPath",
  //   header: "Document",
  //   minWidth: "14rem",
  //   sort: false
  // },
  {
    field: "fromEmail",
    header: "Sender Email ID",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "emailRecievedDateTime",
    header: "Email Received (Pacific Time)",
    minWidth: "18rem",
    sort: true
  },
  {
    field: "actionTakenBy",
    header: "Reviewed By",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "actionTakenDateUTC",
    header: "Reviewed On (Pacific Time)",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "fileName",
    header: "File Name",
    minWidth: "14rem",
    sort: true
  }
];

export const purchaseOrderInvoiceLineItemsColumns = [
  {
    field: "purchaseOrderId",
    header: "PO ID",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "buyerItemId",
    header: "Buyer Item ID",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "quantity",
    header: "Quantity",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "unit",
    header: "Unit",
    minWidth: "8rem",
    sort: true
  },
  {
    field: "lotNumber",
    header: "Lot Number",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "aptInTime",
    header: "In Time",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "aptLoadTime",
    header: "Load Time",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "aptOutTime",
    header: "Out Time",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "recorder",
    header: "Recorder",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "seal",
    header: "Seal",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "temparatureInstructions",
    header: "Temperature Instructions",
    minWidth: "18rem",
    sort: false
  },
  {
    field: "dockDoor",
    header: "Dock Door",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "shippingCarrier",
    header: "Shipping Carrier",
    minWidth: "14rem",
    sort: true
  }
];

export const purchaseOrderColumns = [
  {
    field: "poNumber",
    header: "PO Number",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "d365Status",
    header: "D365 Status",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "d365ErrorMessage",
    header: "D365 Message",
    minWidth: "30rem",
    sort: true
  },
  {
    field: "source",
    header: "Source",
    minWidth: "10rem",
    sort: true
  },
  //TODO: Need to implement
  // {
  //   field: "blobPath",
  //   header: "Blob Path",
  //   minWidth: "18rem",
  //   sort: false
  // },
  {
    field: "shippingDateRequested",
    header: "Shipping Date Requested",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "buyerShipToId",
    header: "Buyer Ship To ID",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "sellerShipToId",
    header: "Seller Ship To ID",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "fromEmail",
    header: "Sender Email ID",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "emailRecievedDateTime",
    header: "Email Received (Pacific Time)",
    minWidth: "18rem",
    sort: true
  },
  ,
  {
    field: "actionTakenBy",
    header: "Reviewed By",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "actionTakenDateUTC",
    header: "Reviewed On (Pacific Time)",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "fileName",
    header: "File Name",
    minWidth: "14rem",
    sort: true
  }
];

export const purchaseOrderLineItemsColumns = [
  {
    field: "buyeritemId",
    header: "Buyer Item Id",
    minWidth: "4rem",
    sort: true
  },
  {
    field: "sellerItemId",
    header: "Seller Item Id",
    minWidth: "4rem",
    sort: true
  },
  {
    field: "quantity",
    header: "Quantity",
    minWidth: "3rem",
    sort: true
  },
  {
    field: "unit",
    header: "Unit",
    minWidth: "3rem",
    sort: false
  }
];

export const salesOrdersPickingColumns = [
  {
    field: "fileName",
    header: "File Name",
    minWidth: "30rem",
    sort: true
  },
  {
    field: "d365Status",
    header: "D365 Status",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "d365ErrorMessage",
    header: "D365 Message",
    minWidth: "30rem",
    sort: true
  },
  {
    field: "source",
    header: "Source",
    minWidth: "10rem",
    sort: true
  },
  {
    field: "fromEmail",
    header: "Sender Email ID",
    minWidth: "15rem",
    sort: true
  },
  //TODO: Need to implement
  // {
  //   field: "blobPath",
  //   header: "Blob Path",
  //   minWidth: "18rem",
  //   sort: false
  // },
  {
    field: "emailRecievedDateTime",
    header: "Email Received (Pacific Time)",
    minWidth: "18rem",
    sort: true
  },
  {
    field: "actionTakenBy",
    header: "Reviewed By",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "actionTakenDateUTC",
    header: "Reviewed On (Pacific Time)",
    minWidth: "16rem",
    sort: true
  }
];

export const salesOrdersPickingItemsColumns = [
  {
    field: "salesOrderId",
    header: "Sales Order ID",
    minWidth: "4rem",
    sort: true
  },
  {
    field: "quantity",
    header: "Quantity",
    minWidth: "3rem",
    sort: true
  },
  {
    field: "buyerItemId",
    header: "Buyer Item Id",
    minWidth: "4rem",
    sort: true
  },
  {
    field: "sellerItemId",
    header: "Seller Item Id",
    minWidth: "4rem",
    sort: true
  }
];

export const sevenElevenOrderColumns =
  [
    {
      field: "regionCode",
      header: "Region Code",
      minWidth: "8rem",
      sort: true
    },
    {
      field: "tradingPartnerName",
      header: "Trading Partner Name",
      minWidth: "8rem",
      sort: true
    },
    {
      field: "actualPOs",
      header: "Actual PO's",
      minWidth: "8rem",
      sort: true
    },
    {
      field: "invalidPOs",
      header: "Invalid PO's",
      minWidth: "8rem",
      sort: true
    },
    {
      field: "d365ProcessedPOs",
      header: "D365 Processed PO's",
      minWidth: "10rem",
      sort: true
    },
    {
      field: "d365FailedPOs",
      header: "D365 Failed PO's",
      minWidth: "10rem",
      sort: true
    },
    {
      field: "createdDatePST",
      header: "Date",
      minWidth: "4rem",
      sort: true,
    },
    {
      field: "orderCreatedTimePST",
      header: "Time (PST)",
      minWidth: "4rem",
      sort: true,
    },
    {
      field: "fileName",
      header: "File Name",
      minWidth: "16rem",
      sort: true
    }];

export const sevenElevenOrderLineItemColumns =
  [{
    field: "poNumber",
    header: "PO Number",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "d365Status",
    header: "D365 Status",
    minWidth: "16rem",
    sort: true
  },
  {
    field: "d365Message",
    header: "Message",
    minWidth: "18rem",
    sort: true,
  },
  {
    field: "shipRequestedDate",
    header: "Ship Date",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "sellerShipToId",
    header: "Seller Ship To Id",
    minWidth: "14rem",
    sort: true
  }, {
    field: "route",
    header: "Route",
    minWidth: "4rem",
    sort: true
  }, {
    field: "stop",
    header: "Stop",
    minWidth: "4rem",
    sort: true
  },
  {
    field: "action",
    header: "Action",
    minWidth: "14rem",
    sort: true
  }

  ];

export const OrderConfigColumns = [
  {
    field: "regionCode",
    header: "Region",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "tradingPartnerDisplayName",
    header: "Trading Partner",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "action",
    header: "Automated",
    minWidth: "10rem",
    sort: false
  },
  {
    field: "approvedBy",
    header: "Approved By",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "approvedDatePST",
    header: "Approved Date",
    minWidth: "14rem",
    sort: true
  }
];

export const krogerRetailColumns = [
  {
    field: "regionCode",
    header: "Region",
    minWidth: "12rem",
    sort: true
  },
  {
    field: "tradingPartnerName",
    header: "Trading Partner",
    minWidth: "11rem",
    sort: true
  },
  {
    field: "invoiceAccounts",
    header: "Invoice Account",
    minWidth: "18rem",
    sort: true
  },
    {
    field: "enabledisable",
    header: "Enable/Disable",
    minWidth: "9rem",
    sort: true
  },
    {
    field: "actionType",
    header: "Item Modification",
    minWidth: "12rem",
    sort: true
  },
      {
    field: "modifiedBy",
    header: "Approved By",
    minWidth: "12rem",
    sort: true
  },
      {
    field: "modifiedDatePST",
    header: "Approved Date PST",
    minWidth: "14rem",
    sort: true
  },
  {
    field: "action",
    header: "Action",
    minWidth: "10rem"
  }
]